<template>
  <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
    <a-form-item ref="type_id" label="店员类型" name="type_id">
      <a-row :gutter="10">
        <a-col :span="16">
          <a-select v-model:value="form.type_id" placeholder="请选择店员类型" @change="changeType" :disabled="type=='edit'">
            <a-select-option v-for='item in typeList' :key='item.id' :value="item.id">{{item.type_name}}
            </a-select-option>
          </a-select>
        </a-col>
      </a-row>
    </a-form-item>
    <a-form-item ref="weight" label="级别" name="weight" hidden>
      <a-row :gutter="10">
        <a-col :span="16">
          <a-input v-model:value="form.weight" placeholder='请输入级别' disabled />
        </a-col>
        <a-col :span="6">
          <p>系统自动按顺序分配</p>
        </a-col>
      </a-row>
    </a-form-item>
    <a-form-item ref="level_name" label="级别名称" name="level_name">
      <a-row :gutter="10">
        <a-col :span="16">
          <a-input v-model:value="form.level_name" placeholder='请输入级别名称' maxlength="10" />
        </a-col>
        <a-col :span="6">
          <p>最多10个字</p>
        </a-col>
      </a-row>
    </a-form-item>

    <a-form-item ref="manage" label="店员管理" name="manage" v-if="form.type_id==2">
      <div>
        <a-radio-group v-model:value="form.manage">
          <a-radio :value="1">
            允许
          </a-radio>
          <a-radio :value="0">
            不允许
          </a-radio>
        </a-radio-group>
      </div>
      <div v-if='form.manage == 1' class="s_flex_ali">
        <a-form-item ref="is_can_add" label="" name="is_can_add" style="margin-bottom: 0;">
          <a-checkbox v-model:checked="form.is_can_add">
            添加店员
          </a-checkbox>
        </a-form-item>
        <a-form-item ref="is_can_del" label="" name="is_can_del" style="margin-bottom: 0;">
          <a-checkbox v-model:checked="form.is_can_del">
            删除店员
          </a-checkbox>
        </a-form-item>
      </div>
    </a-form-item>
    <a-form-item ref="growth_value" label="需成长值达" name="growth_value">
      <a-row :gutter="10" class="m-b-10">
        <a-col :span="16">
          <a-input-number v-model:value="form.growth_value" placeholder='请输入所需成长值'
            :min="leveData.growth_value?leveData.growth_value:0" :disabled="type=='edit'" style="width:100%" />
        </a-col>
      </a-row>
    </a-form-item>
    <a-form-item ref="" label="升级奖励" name="">
      <a-row :gutter="10">
        <a-col :span="16">
          <a-row :gutter="10">
            <a-col :span="6">
              <a-checkbox v-model:checked="form.is_giving_integral">导购积分</a-checkbox>
            </a-col>
            <a-col :span="18">
              <a-input-number v-model:value="form.giving_integral" style="width:100%" :min='1' :max="9999" :disabled="!form.is_giving_integral" :precision="0" placeholder='请输入' />
            </a-col>
          </a-row>
          <a-row :gutter="10">
            <a-col :span="6">
              <a-checkbox v-model:checked="form.is_giving_member_integral">会员积分</a-checkbox>
            </a-col>
            <a-col :span="18">
              <a-input-number v-model:value="form.giving_member_integral" style="width:100%" :min='1' :max="9999" :disabled="!form.is_giving_member_integral" :precision="0" placeholder='请输入' />
            </a-col>
          </a-row>
        </a-col>
        <a-col :span="2">
          <a-tooltip placement="right">
            <template #title>
              升级到该等级时，根据设置的奖励内容，系统自动发放（仅发放一次）
            </template>
            <QuestionCircleOutlined class="s_c376" />
          </a-tooltip>
        </a-col>
      </a-row>
    </a-form-item>
    <a-form-item ref="" label="等级权益" name="">
      <a-row :gutter="10">
        <a-col :span="16">
          <a-row :gutter="10">
            <a-col :span="6">扫码积分翻</a-col>
            <a-col :span="18">
              <a-input-number v-model:value="form.scan_times" style="width:100%" :min='1' :max="10" :precision="1" placeholder='请输入' />
            </a-col>
          </a-row>
        </a-col>
        <a-col :span="4">
          <a-tooltip placement="right">
            <template #title>
              在参加导购扫码活动时，可以根据导购扫码翻倍系数获得导购积分，默认为1.0不翻倍
            </template>
            倍<QuestionCircleOutlined class="s_c376 m-l-10" />
          </a-tooltip>
        </a-col>
      </a-row>
    </a-form-item>
    <a-form-item ref="remarks" label="备注" name="remarks">
      <a-row :gutter="10">
        <a-col :span="16">
          <a-textarea v-model:value="form.remarks" showCount :maxlength="200" placeholder="请输入备注" :rows="4" />
        </a-col>
      </a-row>
    </a-form-item>
    <a-form-item :wrapper-col="{ span: 8, offset: 3 }">
      <a-button type="primary" @click="onSubmit">
        保存
      </a-button>
    </a-form-item>
  </a-form>
</template>
<script>
  import { QuestionCircleOutlined } from "@ant-design/icons-vue";
  import { ref, onMounted, reactive, toRefs, watchEffect } from 'vue';
  import { message } from 'ant-design-vue';
  import { getTypeList, getlevelMore } from "@/api/clerk";
  import { iscode } from "@/utils/app";
  import { setlevelAdd, levelEdit, getlevelMax } from "@/api/clerk";
  // 初始化默认筛选项数值
  let defForm = {
    weight: '',
    level_name: '',
    type_id: '',
    growth_value: '',
    is_can_add: 0,
    is_can_del: 0,
    scan_times: 1.0,
    remarks: '',
    manage: 0,
    is_scan: 0,
    is_giving_integral: 0,
    giving_integral: 1,
    is_giving_member_integral:0,
    giving_member_integral:1
  }
  export default {
    name: 'levelAdd',
    components: { QuestionCircleOutlined },
    props: {
      type: {
        type: String
      },
      id:{
        type:Number
      }
    },
    setup(props, { emit }) {
      //pass
      const form = ref({ ...defForm });
      const state = reactive({
        leveData: {},
        typeList: [],
        labelCol: { span: 3 },
        wrapperCol: { span: 21 },
        rules: {
          weight: [
            { required: true, message: '请输入级别' }
          ],
          level_name: [
            { required: true, message: '请输入级别名称' }
          ],
          type_id: [
            { required: true, message: '请选择级别类型' }
          ],
          growth_value: [
            { required: true, message: '请选输入所需成长值' }
          ],
        }
      });
      const ruleForm = ref()
      const getType = async () => {
        let res = await getTypeList().then(res => res.data).catch((error) => error);
        if (iscode(res)) {
          state.typeList = res.data.data;
        } else {
          message.error(res.msg);
        }
      }
      const changeType = async () => {
        let res = await getlevelMax({ type_id: form.value.type_id }).then(res => res.data).catch((error) => error);
        if (iscode(res)) {
          form.value.weight = 1
          if (res.data.weight) {
            state.leveData = res.data;
            form.value.weight = parseInt(res.data.weight) + 1
          }
        } else {
          message.error(res.msg);
        }
      }
      const getMore = async () => {
        let res = await getlevelMore(props.id).then(res => res.data).catch((error) => error);
        if (iscode(res)) {
          form.value = res.data;
          if (res.data.is_can_add == 1 || res.data.is_can_del == 1) {
            form.value.manage = 1
          }
          if (!res.data.is_can_add == 1 && !res.data.is_can_del == 1) {
            form.value.manage = 0
          }
        } else {
          message.error(res.msg);
        }
      }
      const onSubmit = () => {
        ruleForm.value.validate().then(async () => {
          let res;
          const hide = message.loading("正在加载中...", 0);
          if (props.type=='edit') {
            res = await levelEdit(
              {
                ...form.value,
                is_can_add: form.value.manage == 0 ? 0 : form.value.is_can_add,
                is_can_del: form.value.manage == 0 ? 0 : form.value.is_can_del,
                is_giving_integral: form.value.is_giving_integral?1:0,
                is_giving_member_integral:form.value.is_giving_member_integral?1:0,
              },
              form.value.id
            ).then((res) => res.data).catch((error) => error);
          } else {
            res = await setlevelAdd({
              ...form.value,
              is_can_add: form.value.manage == 0 ? 0 : form.value.is_can_add,
              is_can_del: form.value.manage == 0 ? 0 : form.value.is_can_del,
              is_giving_integral: form.value.is_giving_integral?1:0,
              is_giving_member_integral:form.value.is_giving_member_integral?1:0,
            }).then((res) => res.data).catch((error) => error);
          }
          setTimeout(hide);
          if (iscode(res)) {
            message.success(res.msg);
            emit('onsubmit')
            ruleForm.value.resetFields();
          } else {
            message.error(res.msg);
          }
        }).catch(error => {
          message.error('请完善表单！');
        });
      }
      onMounted(() => {
        getType();
        if(props.type=='edit') {
          getMore();
        }
      });
      return {
        form,
        ...toRefs(state),
        ruleForm,
        onSubmit,
        changeType
      }
    }
  }
</script>